import { ArticleCard } from '@components/common'
import cn from 'clsx'
import Link from 'next/link'
interface Props {
  slice: any
}
const FeaturedArticles = ({ slice }: Props) => {
  const { primary } = slice
  const layout = primary?.layout
  const leftArticle = primary?.leftArticle
  const rightArticle = primary?.rightArticle
  const linkText = primary?.linkText
  const link = primary?.link

  return <>
    <div className="bg-ui-light-grey wrapper pt-0 pb-8 lg:pt-30 lg:pb-20 flex flex-col">
      <div className=" lg:grid hidden lg:grid-cols-12 gap-8">
        <div
          className={cn(
            'col-span-3',
            { 'lg:col-start-2 lg:col-span-4': layout },
            { 'lg:col-start-2 lg:col-span-5': !layout }
          )}
        >
          <ArticleCard
            featured
            uid={leftArticle?.uid}
            article={leftArticle?.data}
          />
          {link && linkText && !layout && (
            <Link href={link} passHref legacyBehavior>
              <div className="cursor-pointer text-2xl mt-20  font-light font-roboto text-brand-dark-grey underline hover:opacity-75">
                {linkText}
              </div>
            </Link>
          )}
        </div>
        <div
          className={cn(
            'flex flex-col col-span-3',
            { 'lg:col-start-7 lg:col-span-5': layout },
            { 'lg:col-start-8 lg:col-span-4': !layout }
          )}
        >
          <ArticleCard
            featured
            uid={rightArticle?.uid}
            article={rightArticle?.data}
          />
          {link && linkText && layout && (
            <Link href={link} passHref legacyBehavior>
              <div className="cursor-pointer self-end text-2xl mt-20  font-light font-roboto text-brand-dark-grey underline hover:opacity-75">
                {linkText}
              </div>
            </Link>
          )}
        </div>
      </div>
      <div className="lg:hidden flex flex-col gap-[52px]">
        <div className="lg:hidden grid overflow-x-scroll featuredArticleContainer">
          <ArticleCard
            featured
            uid={leftArticle?.uid}
            article={leftArticle?.data}
          />
          <ArticleCard
            featured
            uid={rightArticle?.uid}
            article={rightArticle?.data}
          />
        </div>
        {link && linkText && (
          <Link href={link} passHref legacyBehavior>
            <div className="self-center heading-mobile-4 underline hover:opacity-75">
              {linkText}
            </div>
          </Link>
        )}
      </div>
    </div>
    <style jsx>
      {`
        .stockistContainer {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .featuredArticleContainer::-webkit-scrollbar {
          display: none;
        }
        @media (max-width: 1023px) {
          .featuredArticleContainer {
            --visible-cols: 2;
            --col-gap: 24px;
            --col-hint: 0px;
            --col-size: calc(
              (100% / var(--visible-cols)) - var(--col-gap) - var(--col-hint)
            );
            grid-auto-flow: column;
            grid-template-columns: var(--col-size);
            grid-auto-columns: var(--col-size);
            grid-gap: 24px;
          }
        }
        @media (max-width: 425px) {
          .featuredArticleContainer {
            --visible-cols: 1;
            --col-gap: 24px;
            --col-hint: 80px;
            --col-size: calc(
              (100% / var(--visible-cols)) - var(--col-gap) - var(--col-hint)
            );
            grid-auto-flow: column;
            grid-template-columns: var(--col-size);
            grid-auto-columns: var(--col-size);
            grid-gap: 24px;
          }
        }
      `}
    </style>
  </>;
}

export default FeaturedArticles
